import { Card } from '../ui';

type Props = {
  insights?: string[];
};

export function ContentCopilotCard({ insights = [] }: Props) {
  return (
    <Card padding="sm" className="border-ai-200 bg-ai-50/20 dark:border-ai-900 dark:bg-ai-950/20">
      <p className="text-xs font-semibold uppercase tracking-wide text-ai-600">AI Content Copilot</p>
      <ul className="mt-3 space-y-2">
        {insights.map((insight) => (
          <li key={insight} className="flex gap-2 text-sm text-slate-600 dark:text-slate-400">
            <span className="text-ai-500">◆</span>
            {insight}
          </li>
        ))}
      </ul>
    </Card>
  );
}
